import { useTranslation as _useTranslation } from "react-i18next";

/**
 * Adding a prefix capability so it's
 * eeasier to be backward compatible with
 * the legacy codebase
 */
export default function useTranslation(prefix = "") {
  const { t } = _useTranslation();
  return (key: string, options?: Record<string, unknown>) =>
    t(`${prefix ? `${prefix}.` : ""}${key}`, options);
}
